(function ($) {
  $(document).ready(function() {
    $('.f-item--radio label, .f-item--checkbox label').click(function() {
      var $checkbox = $(this).prev();
      $checkbox.prop('checked', !$checkbox.is(':checked') || $checkbox.is('[type="radio"]'));
    });

    // $('[value="274333"]').click(function(e) {
    //   if ($(this).is(':checked')) {
    //     var $row = $(this).parent().parent();
    //     $(':input',$row).not(this).prop('checked',false);
    //   }
    // });
    var inputs = '[name="88908"]';
    var allField = '[value="274333"]';
    $(inputs).click(function() {
      var $row = $(this).parent().parent();
      if ($(this).is(allField)) {
        $(':input',$row).not(this).prop('checked',false);
      }
      else {
        var allChecked = true;
        $(inputs).not(allField).each(function() {
          allChecked = !$(this).is(':checked') ? false : allChecked;
        });
        $(allField).prop('checked', false);
        if (allChecked) {
          $(inputs).prop('checked',false);
          $(allField).prop('checked',true);
        }
      }
    });
  });
})(jQuery);

Theme = {
  eta: 300,
  gutter: 30,
  breakpoint: {
    tiny: 360,
    small: 560,
    medium: 850,
    desktop: 960,
    max: 1365,
  },
};

(function ($) {
  $(document).ready(function() {
    // if (window.location.hash != '') {
    //   scrollTo(window.location.hash);
    // }
    $('[href^="#"]').click(function(e) {
      $('body').removeClass('js-ham-open');
      scrollTo($(this).attr('href'));
    });
    if (window.location.pathname == '/') {
      $('[href^="/#"]').click(function (e) {
        $('body').removeClass('js-ham-open');
        var href = String($(this).attr('href')).split('');
        href.shift();
        scrollTo(href.join(''));
      });
    }

    //Modal
    $('.toggle-modal').click(function(e) {
      e.preventDefault();
      $('body').toggleClass('js-ham-open');
      if ($('body').hasClass('js-ham-open')) {
        $('.modal').hide().fadeIn(Theme.eta);
      }
      else {
        $('.modal').show().fadeOut(Theme.eta);
      }
    });

    //Initialize rows
    checkRowsInit();
    $(window).scroll(checkRowsInit);

    //Select elements
    $('select').selectric();
  });

  var scrollTo = function(id) {
    $('html,body').animate({
      scrollTop: $(id).offset().top,
    }, Theme.eta);
  };

  var rowsToInit = [
    '.h',
    '.c',
  ];
  var checkRowsInit = function () {
    var windowBottom = $(window).scrollTop() + ($(window).height() * 0.5);
    $(rowsToInit.join(',')).filter(':not(.js-initialized)').each(function () {
      if (windowBottom > $(this).offset().top) {
        $(this).addClass('js-initialized').trigger('initialized');
      }
    });
  };
})(jQuery);
